<template>
  <div class="importar-preventivas" v-if="isFabricio">
    <div class="card">
      <div class="card-header">
        <h3>Importar Dados de Preventivas</h3>
      </div>

      <div class="card-body">
        <div v-if="carregando && acaoEmProgresso !== 'calcular-base24-25'" class="loading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Carregando...</span>
          </div>
          <p>Importando dados, por favor aguarde...</p>
        </div>

        <div v-else-if="erro" class="alert alert-danger">
          {{ erro }}
        </div>

        <div v-else-if="resultadoImportacao" class="alert alert-success">
          <h4>Ação concluída!</h4>
          <p v-if="resultadoImportacao.message">{{ resultadoImportacao.message }}</p>
          <div v-if="resultadoImportacao.dados_importados">
            <p>Registros afetados:</p>
            <ul>
              <li v-if="resultadoImportacao.dados_importados.base24_25 !== undefined"><strong>Base24_25:</strong> {{ resultadoImportacao.dados_importados.base24_25 }} registros</li>
              <li v-if="resultadoImportacao.dados_importados.valores_mensais_predios_2025 !== undefined"><strong>Valores Mensais Prédios 2025:</strong> {{ resultadoImportacao.dados_importados.valores_mensais_predios_2025 }} registros</li>
              <li v-if="resultadoImportacao.dados_importados.valores_faturamento !== undefined"><strong>Valores Faturamento:</strong> {{ resultadoImportacao.dados_importados.valores_faturamento }} registros</li>
            </ul>
          </div>
          <button class="btn btn-primary mt-3" @click="limparResultado">Nova ação</button>
        </div>

        <div v-else>
          <div v-if="statusDados" class="mb-4">
            <h4>Status Atual:</h4>
            <div class="card bg-light p-3">
              <div class="row">
                <div class="col-md-4">
                  <h5>Base24_25</h5>
                  <div v-if="statusDados.base24_25.tem_dados" class="alert alert-info">
                    Existem {{ statusDados.base24_25.total }} registros na tabela.
                  </div>
                  <div v-else class="alert alert-warning">
                    Não existem registros na tabela.
                  </div>
                </div>
                <div class="col-md-4">
                  <h5>Valores Mensais Prédios 2025</h5>
                  <div v-if="statusDados.valores_mensais_predios_2025.tem_dados" class="alert alert-info">
                    Existem {{ statusDados.valores_mensais_predios_2025.total }} registros na tabela.
                  </div>
                  <div v-else class="alert alert-warning">
                    Não existem registros na tabela.
                  </div>
                </div>
                <div class="col-md-4 mt-3">
                  <h5>Valores Faturamento</h5>
                  <div v-if="statusDados.valores_faturamento && statusDados.valores_faturamento.tem_dados" class="alert alert-info">
                    Existem {{ statusDados.valores_faturamento.total }} registros na tabela.
                  </div>
                  <div v-else class="alert alert-warning">
                    Não existem registros na tabela.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="alert alert-info">
            <h5>Arquivo para importação:</h5>
            <p><strong>Preventivas_2024_2025.xls</strong></p>
            <p>Este arquivo já está disponível no servidor e será importado diretamente sem necessidade de upload.</p>
          </div>

          <div class="form-group mt-3">
            <div class="btn-group mb-2" role="group">
              <button type="button" class="btn btn-primary" @click="importarBase2425" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'importar-base24-25'"><i class="fa fa-spinner fa-spin"></i> Importando...</span>
                <span v-else>Importar Base24_25</span>
              </button>
              <button type="button" class="btn btn-primary" @click="importarValores2025" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'importar-valores-2025'"><i class="fa fa-spinner fa-spin"></i> Importando...</span>
                <span v-else>Importar Valores 2025</span>
              </button>
              <button type="button" class="btn btn-primary" @click="importarValoresFaturamento" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'importar-valores-faturamento'"><i class="fa fa-spinner fa-spin"></i> Importando...</span>
                <span v-else>Importar Valores Faturamento</span>
              </button>
            </div>
            <div class="btn-group mb-2 ml-2" role="group">
              <button type="button" class="btn btn-danger" @click="limparBase2425" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'limpar-base24-25'"><i class="fa fa-spinner fa-spin"></i> Limpando...</span>
                <span v-else>Limpar Base24_25</span>
              </button>
              <button type="button" class="btn btn-danger" @click="limparValores2025" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'limpar-valores-2025'"><i class="fa fa-spinner fa-spin"></i> Limpando...</span>
                <span v-else>Limpar Valores 2025</span>
              </button>
              <button type="button" class="btn btn-danger" @click="limparValoresFaturamento" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'limpar-valores-faturamento'"><i class="fa fa-spinner fa-spin"></i> Limpando...</span>
                <span v-else>Limpar Valores Faturamento</span>
              </button>
            </div>
            <div class="mt-2">
              <button type="button" class="btn btn-warning" @click="calcularBase2425()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'calcular-base24-25'"><i class="fa fa-spinner fa-spin"></i> Calculando...</span>
                <span v-else>Calcular Base24_25</span>
              </button>
              <button type="button" class="btn btn-info ml-2" @click="calcularValorFixoMensal()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'calcular-valor-fixo-mensal'"><i class="fa fa-spinner fa-spin"></i> Calculando...</span>
                <span v-else>Calcular Valor Fixo Mensal - Faturamento</span>
              </button>
              <button type="button" class="btn btn-info ml-2" @click="calcularValorFixoMensalRestante()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'calcular-valor-fixo-mensal-restante'"><i class="fa fa-spinner fa-spin"></i> Calculando...</span>
                <span v-else>Calcular Valor Fixo Mensal - Restante</span>
              </button>
              <button type="button" class="btn btn-success ml-2" @click="calcularCamposDerivadosBase()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'calcular-campos-derivados-base24-25'"><i class="fa fa-spinner fa-spin"></i> Calculando...</span>
                <span v-else>Calcular Campos Derivados</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="ajustarValorFixoZero()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'ajustar-valor-fixo-zero'"><i class="fa fa-spinner fa-spin"></i> Ajustando...</span>
                <span v-else>Ajustar Valor Fixo = 0</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoQteProgramada()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-qte-programada'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>1) Recalcular Período - Qte Programada</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoQtesEntregues()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-qtes-entregues'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>2) Recalcular Período - Entregue + Não entregues</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoTaxaEntrega()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-taxa-entrega'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>3) Recalcular Período - Taxa entrega</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoSomaValoresEntregues()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-soma-entregues'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>4) Recalcular Período - Soma valores ENTREGUES</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoSomaValoresNaoEntregues()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>5) Recalcular Período - Soma valores NÃO ENTREGUES</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoSomaValoresEntreguesDispersos()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-soma-entregues-dispersos'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>6) Recalcular Período - Soma ENTREGUES Dispersos</span>
              </button>
              <button type="button" class="btn btn-primary ml-2" @click="recalcularPeriodoSomaValoresNaoEntreguesDispersos()" :disabled="carregando || acaoEmProgresso !== null">
                <span v-if="acaoEmProgresso === 'recalcular-periodo-soma-nao-entregues-dispersos'"><i class="fa fa-spinner fa-spin"></i> Recalculando...</span>
                <span v-else>7) Recalcular Período - Soma NÃO ENTREGUES Dispersos</span>
              </button>
            </div>

            <button type="button" class="btn btn-primary ml-2" @click="exportarBaseSimulacao()" :disabled="carregando || acaoEmProgresso !== null">
              <span v-if="acaoEmProgresso === 'export-base-simulacao'"><i class="fa fa-spinner fa-spin"></i> Exportando...</span>
              <span v-else>Final) Exportar Base + Simulação</span>
            </button>
            <span v-if="pendentesInfo" class="badge badge-warning ml-2" title="Pendentes na outbox + pendências de cálculo na base">
              Pendentes: {{ pendentesInfo.pendentes_total }}
            </span>
            <div class="mt-2">
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-outline-primary" @click="etapaCalcularValorFixoMensal" :disabled="carregando || acaoEmProgresso !== null">
                  1) Valor Fixo (faturamento)
                </button>
                <button type="button" class="btn btn-outline-primary" @click="etapaAjustarZero" :disabled="carregando || acaoEmProgresso !== null">
                  2) Ajustar Valor Fixo = 0
                </button>
                <button type="button" class="btn btn-outline-primary" @click="etapaCalcularDerivados" :disabled="carregando || acaoEmProgresso !== null">
                  3) Campos Derivados
                </button>
                <button type="button" class="btn btn-outline-secondary" @click="carregarPendentes" :disabled="carregando || acaoEmProgresso !== null">
                  Atualizar Pendentes
                </button>
              </div>
              <button type="button" class="btn btn-success ml-2" @click="executarEtapasPreExport" :disabled="carregando || acaoEmProgresso !== null">
                Executar etapas 1-3
              </button>
            </div>
            <div class="mt-2">
              <button type="button" class="btn btn-primary" @click="$router.push('/simulacao-geral')">Voltar para Simulação</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="alert alert-warning m-3">Acesso restrito.</div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'ImportarPreventivas',

  data() {
    return {
      env: process.env,
      carregando: false,
      erro: null,
      resultadoImportacao: null,
      statusDados: null,
      acaoEmProgresso: null,
      progresso: null,
      progressoActive: false,
      progressoTimeoutId: null,
      pendentesInfo: null
    }
  },

  computed: {
    progressoPercentual() {
      if (!this.progresso || !this.progresso.total || this.progresso.total === 0) return 0
      const pct = Math.floor((this.progresso.atual / this.progresso.total) * 100)
      return pct > 100 ? 100 : pct
    },
    isFabricio() {
      try {
        const email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase()
        return email === 'fabricio.elias@portalssp.com'
      } catch (e) {
        return false
      }
    }
  },

  created() {
    if (!this.isFabricio) return
    this.verificarStatus()
    this.carregarPendentes()
  },

  methods: {
    exportarBaseSimulacao() {
      this.acaoEmProgresso = 'export-base-simulacao'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/export-base-simulacao`,
        method: 'post',
        data: {},
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          const arquivo = response.data && response.data.arquivo_download
          if (arquivo) {
            const urlDownload = `${this.env.FINANCEIRO.SLA}/download-arquivo-xlsx/${arquivo}`
            axios.get(urlDownload, {
              responseType: 'blob',
              headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
            }).then((resp) => {
              const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              const link = document.createElement('a')
              const url = window.URL.createObjectURL(blob)
              link.href = url
              // tenta usar o nome sugerido; fallback para nome padrão
              const sugestao = (response.data && response.data.arquivo_download) || `BaseESimulacao-${new Date().toISOString().slice(0, 10)}.xlsx`
              link.setAttribute('download', sugestao)
              document.body.appendChild(link)
              link.click()
              link.parentNode.removeChild(link)
              window.URL.revokeObjectURL(url)
            }).catch(err => {
              // fallback: abre em nova aba (caso o blob falhe)
              window.open(urlDownload, '_blank')
            })
          }
          this.carregando = false
          this.acaoEmProgresso = null
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'export-base-simulacao') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },
    atualizarQteProgramada() {
      this.acaoEmProgresso = 'atualizar-qte-programada'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/atualizar-qte-programada`,
        method: 'post',
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => {
          this.resultadoImportacao = response.data
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => {
          this.carregando = false
          this.acaoEmProgresso = null
        })
    },
    montarExportQteProgramada() {
      this.acaoEmProgresso = 'montar-export-qte-programada'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-export/montar-qte-programada`,
        method: 'post',
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    montarExportQteProgramadaDeCache() {
      this.acaoEmProgresso = 'montar-export-qte-programada-de-cache'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-export/montar-qte-programada-de-cache`,
        method: 'post',
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    importarModeloQteProgramadaExtras() {
      this.acaoEmProgresso = 'importar-modelo-qte-extras'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-export/importar-modelo-qte-programada-extras`,
        method: 'post',
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    montarExportQteProgramadaDeCache() {
      this.acaoEmProgresso = 'montar-export-qte-programada-de-cache'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-export/montar-qte-programada-de-cache`,
        method: 'post',
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoQteProgramada() {
      this.acaoEmProgresso = 'recalcular-periodo-qte-programada'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-qte-programada`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoQteEntregue() {
      this.acaoEmProgresso = 'recalcular-periodo-qte-entregue'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-qte-entregue`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoQtesEntregues() {
      this.acaoEmProgresso = 'recalcular-periodo-qtes-entregues'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-qtes-entregues`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoSomaValoresEntregues() {
      this.acaoEmProgresso = 'recalcular-periodo-soma-entregues'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-soma-entregues`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoSomaValoresNaoEntregues() {
      this.acaoEmProgresso = 'recalcular-periodo-soma-nao-entregues'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-soma-nao-entregues`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoSomaValoresEntreguesDispersos() {
      this.acaoEmProgresso = 'recalcular-periodo-soma-entregues-dispersos'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-soma-entregues-dispersos`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoSomaValoresNaoEntreguesDispersos() {
      this.acaoEmProgresso = 'recalcular-periodo-soma-nao-entregues-dispersos'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-soma-nao-entregues-dispersos`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoTaxaEntrega() {
      this.acaoEmProgresso = 'recalcular-periodo-taxa-entrega'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-taxa-entrega`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    recalcularPeriodoQteNaoEntregue() {
      this.acaoEmProgresso = 'recalcular-periodo-qte-nao-entregue'
      axios({
        url: `${this.env.FINANCEIRO.SLA}/simulacao-agregados/recalcular-periodo-qte-nao-entregue`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => { this.resultadoImportacao = response.data })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => { this.carregando = false; this.acaoEmProgresso = null })
    },
    importarBase2425() {
      this.executarAcao('importar-base24-25', 'post')
    },
    ajustarValorFixoZero() {
      this.acaoEmProgresso = 'ajustar-valor-fixo-zero'

      return axios({
        url: `${this.env.FINANCEIRO.SLA}/ajustar-valor-fixo-zero`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          this.carregando = false
          this.acaoEmProgresso = null
          this.verificarStatus()
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'ajustar-valor-fixo-zero') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },
    calcularCamposDerivadosBase() {
      this.acaoEmProgresso = 'calcular-campos-derivados-base24-25'

      return axios({
        url: `${this.env.FINANCEIRO.SLA}/calcular-campos-derivados-base24-25`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          this.carregando = false
          this.acaoEmProgresso = null
          this.verificarStatus()
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'calcular-campos-derivados-base24-25') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },
    importarValores2025() {
      this.executarAcao('importar-valores-2025', 'post')
    },
    importarValoresFaturamento() {
      this.executarAcao('importar-valores-faturamento', 'post')
    },
    limparBase2425() {
      this.executarAcao('limpar-base24-25', 'delete')
    },
    limparValores2025() {
      this.executarAcao('limpar-valores-2025', 'delete')
    },
    limparValoresFaturamento() {
      this.executarAcao('limpar-valores-faturamento', 'delete')
    },
    iniciarPollingProgresso() {
      this.pararPollingProgresso()
      this.progresso = { total: 0, atual: 0, status: 'running' }
      this.progressoActive = true
      this.doProgressoPoll()
    },
    pararPollingProgresso() {
      this.progressoActive = false
      if (this.progressoTimeoutId) {
        clearTimeout(this.progressoTimeoutId)
        this.progressoTimeoutId = null
      }
    },
    calcularBase2425() {
      this.acaoEmProgresso = 'calcular-base24-25'

      axios({
        url: `${this.env.FINANCEIRO.SLA}/calcular-base24-25`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          this.carregando = false
          this.acaoEmProgresso = null
          this.verificarStatus()
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'calcular-base24-25') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })

    },
    calcularValorFixoMensal() {
      this.acaoEmProgresso = 'calcular-valor-fixo-mensal'

      axios({
        url: `${this.env.FINANCEIRO.SLA}/calcular-valor-fixo-mensal`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          this.carregando = false
          this.acaoEmProgresso = null
          this.verificarStatus()
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'calcular-valor-fixo-mensal') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },
    calcularValorFixoMensalRestante() {
      this.acaoEmProgresso = 'calcular-valor-fixo-mensal-restante'

      axios({
        url: `${this.env.FINANCEIRO.SLA}/calcular-valor-fixo-mensal-restante`,
        method: 'post',
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          this.resultadoImportacao = response.data
          this.carregando = false
          this.acaoEmProgresso = null
          this.verificarStatus()
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
          this.acaoEmProgresso = null
        })
        .finally(() => {
          if (this.acaoEmProgresso !== 'calcular-valor-fixo-mensal-restante') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },
    doProgressoPoll() {
      if (!this.progressoActive || this.acaoEmProgresso !== 'calcular-base24-25') return
      axios.get(`${this.env.FINANCEIRO.SLA}/progresso-base24-25`, {
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      }).then(resp => {
        if (resp.data && resp.data.success) {
          this.progresso = resp.data.progresso
          if (this.progresso && this.progresso.status === 'running') {
            // Agenda próxima consulta apenas após sucesso
            this.progressoTimeoutId = setTimeout(() => this.doProgressoPoll(), 1500)
          } else {
            // Concluído ou falhou
            this.pararPollingProgresso()
            this.acaoEmProgresso = null
          }
        }
      }).catch(() => {
        // Em erro, parar polling para não sobrecarregar
        this.pararPollingProgresso()
      })
    },
    executarAcao(endpoint, method) {
      this.erro = null
      this.resultadoImportacao = null
      this.acaoEmProgresso = endpoint

      if (endpoint !== 'calcular-base24-25') {
        this.carregando = true
      } else {
        this.iniciarPollingProgresso()
      }

      axios({
        url: `${this.env.FINANCEIRO.SLA}/${endpoint}`,
        method: method,
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          if (response.data.success) {
            this.resultadoImportacao = response.data
            this.verificarStatus()
          } else {
            this.erro = response.data.message || 'Operação com falhas'
          }
        })
        .catch(error => {
          let mensagemErro = error.message
          if (error.response && error.response.data && error.response.data.message) {
            mensagemErro = error.response.data.message
          }
          this.erro = 'Erro: ' + mensagemErro
        })
        .finally(() => {
          if (endpoint !== 'calcular-base24-25') {
            this.carregando = false
            this.acaoEmProgresso = null
          }
        })
    },

    verificarStatus() {
      this.carregando = true

      axios.get(`${this.env.FINANCEIRO.SLA}/status-importacao`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
        .then(response => {
          if (response.data.success) {
            this.statusDados = response.data
          }
          this.carregando = false
        })
        .catch(error => {
          console.error('Erro ao verificar status:', error)
          this.carregando = false
        })
    },

    limparResultado() {
      this.resultadoImportacao = null
      this.verificarStatus()
    },
    etapaCalcularValorFixoMensal() {
      return this.calcularValorFixoMensal()
    },
    etapaAjustarZero() {
      return this.ajustarValorFixoZero()
    },
    etapaCalcularDerivados() {
      return this.calcularCamposDerivadosBase()
    },
    carregarPendentes() {
      axios.get(`${this.env.FINANCEIRO.SLA}/base2425/pendingCount`, {
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      }).then(resp => {
        if (resp.data && resp.data.success) this.pendentesInfo = resp.data
      }).catch(() => { /* silencioso */ })
    },
    async executarEtapasPreExport() {
      try {
        await this.etapaCalcularValorFixoMensal()
        await this.etapaAjustarZero()
        await this.etapaCalcularDerivados()
        await this.carregarPendentes()
      } catch (e) {
        // noop
      }
    }
  }
}
</script>
<style scoped>
.importar-preventivas {
  padding: 20px;
}

.card {
  margin-bottom: 30px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
  text-align: center;
}

.spinner-border {
  margin-bottom: 15px;
}

.progress {
  height: 22px;
}

.progress-bar {
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// ImportarPreventivas.vue?2a048b10